export default {
  title: 'Pankkitiedot',
  buttons: {
    save: 'Tallenna',
  },
  toasts: {
    success: 'Tietosi tallennettiin onnistuneesti.',
  },
};
